export default __webpack_public_path__ + "96be27adb675c1cc56c3527ca7ad1c65.svg";